import React from "react";
import {connect} from "react-redux";
import languages from "../collections/languages"

class tooltipLabel extends React.Component {
    constructor(props) {
        super ( props );
        this.state = {
            lang : this.props.lang
        };
        this.hasIcon = this.hasIcon.bind ( this );
        this.hasTooltip = this.hasTooltip.bind ( this );

    }

    handleMouseIn() {
        this.setState ( { hover : true } )
    }

    handleMouseOut() {
        this.setState ( { hover : false } )
    }

    hasIcon() {
        if (!!this.props.tooltip) {
            return <img src={require ( "../images/pngegg.png" )} alt={"..."}/>;
        }
    }

    hasTooltip() {
        if (!!this.props.tooltip) {
            return <div>
                <div
                    style={{ display : this.state.hover ? 'block' : 'none' }}
                    className={"tooltip"}>
                    {!languages[this.props.lang] ? " " : languages[this.props.lang][this.props.tooltip]}
                </div>
            </div>;
        }
    }

    render() {
            return(
            <div className={"w-100 label-box flex"}>
                <div style={{display: "flex",
                    alignItems: "center",
                    flexGrow: 1}}
                    onMouseOver={this.handleMouseIn.bind ( this )}
                     onMouseOut={this.handleMouseOut.bind ( this )}
                     className={"label"}>
                    {!languages[this.props.lang] ? " " : languages[this.props.lang][this.props.text]}
                    {!!this.props.highlight && <div style={{fontSize: "10px", borderBottom:"1px solid red", display: "flex",
                        alignItems: "center", marginLeft:"15px" }}><div style={{color:"#fff", backgroundColor:"red", padding: "0 5px", fontWeight:900}}>{"<"}</div>{this.props.highlight}</div>}
                    {this.hasIcon ()}
                </div>
                {this.hasTooltip ()}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return ({
        lang : state ? state.lang : '' ,
    });
};

export const Label = connect ( mapStateToProps ) ( tooltipLabel );